module.exports = __webpack_public_path__ + "static/img/hussar_develop_face.a72895c.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/documentPage/hussar_develop_face.webp
// module id = 8TvA
// module chunks = 0